/**
 * Redux-selector for sykefraværsstatistikk.
 * Wrapper rundt den rene kalkulatoren som henter data fra Redux state.
 */

import { employeesForStaffingCalendar, holidaysForStaffingCalendar } from 'src/store/selectors';
import type { State } from 'src/store/types.js';
import type { AbsenceEmployee } from './sickness-absence-types';
import { calculateSicknessAbsenceStatsFromData } from './sickness-absence-calculator';
import type { SicknessAbsenceStatsData } from '../pages/staffing-page/sickness-absence-stats-data';
import type { SicknessAbsenceStatsNoGender } from '../pages/staffing-page/sickness-absence-stats-no-gender';

export function calculateSicknessAbsenceStats(state: State): SicknessAbsenceStatsData | SicknessAbsenceStatsNoGender {
  const employees = employeesForStaffingCalendar(state);
  const holidays = holidaysForStaffingCalendar();

  if (!employees || employees.length === 0) {
    return {
      genderDefined: true,
      years: [],
    };
  }

  const endYear = Number(state.today.substring(0, 4));
  return calculateSicknessAbsenceStatsFromData(employees as AbsenceEmployee[], holidays, endYear);
}
